<div class="text-center">
  <table mat-table [dataSource]="role.levels">
    <ng-container matColumnDef="grades">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element" class="node-bg">
        <ng-container *ngFor="let grade of orderGrades(element.grades); let i=index">
          <div class="grade" [class.isMyCareer]=" employeeDetails && employeeDetails.gradeId && grade.id == employeeDetails.gradeId &&
            role.roleId == (employeeDetails.roleId == 66 ? 56 :
            employeeDetails.roleId == 53 ? 51 :
            employeeDetails.roleId == 43 ? 33 :
            employeeDetails.roleId == 72 ? 18 :
            employeeDetails.roleId  == 8 ? 16 :
            employeeDetails.roleId == 72 ? 68 :
            employeeDetails.roleId == 73 ? 10 :
            employeeDetails.roleId == 74 ? 56 :
            employeeDetails.roleId == 75 ? 53 :
            employeeDetails.roleId == 76 ? 33 :
            employeeDetails.roleId == 77 ? 48 :
            employeeDetails.roleId)">
            <div class="d-flex align-items-center">
              <div class="grade-text" [ngClass]="grade.name">{{grade.name}}</div>
              <div class="pl-2 text-left">
                <div class="level-text">
                  {{ role.roleName == 'Trainee' ? role.roleName + ' / Jr.Software Engineer' : 
                     (role.roleName == 'Software Engineer' ? role.roleName + ' / System Engineer' : 
                     (role.roleName == 'Senior Software Engineer' ? role.roleName + ' / Senior System Engineer' : role.roleName)) }}
                </div>
                <a class="menu-link" style="font-weight: 500;"
                  [style.cursor]=" grade.courses > 0 ? 'pointer' : 'default' "
                  (click)="goToProgram(grade)">{{grade.programs.length > 0 ? grade.programs.length : '0'
                  }} Programs |{{grade.courses != null ? grade.courses: '0' }} Courses</a>
              </div>
            </div>
          </div>
        </ng-container>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="['grades']"></tr>
    <tr mat-row *matRowDef="let row; columns: ['grades'];"></tr>
  </table>
</div>
